import { Navigate, useLocation } from 'react-router-dom';

/** Maps old `/webAppOnboarding/v2/*` URLs to `/webAppOnboarding/*` (query + hash preserved). */
export function WebAppOnboardingLegacyUrlRedirect() {
  const location = useLocation();
  const suffix = location.pathname.replace(/^\/webAppOnboarding\/v2\/?/, '');
  const path = suffix.length > 0 ? `/webAppOnboarding/${suffix}` : '/webAppOnboarding';
  const to = `${path}${location.search}${location.hash}`;
  return <Navigate to={to} replace />;
}
